/* eslint-disable prettier/prettier */
import { colors } from '&assets/constants/colors';
import { device } from '&assets/constants/responsiveness';
import styled from 'styled-components';

export const ChallengesWrapper = styled.div`
	padding-top: 100px;
	.content {
		padding: 50px 0px;
		.loading-center{
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 20px;
			.MuiCircularProgress-colorInherit{
				color:${colors.primary}
			}
		}
	}
	.title {
		margin-top: 0;
		font-family: 'Signifier-Regular';
		font-size: 2.25rem;
		line-height: 2.5rem;
		letter-spacing: -0.03em;
		color: ${colors.textDark};
	}
	.description {
		font-size: 1rem;
		line-height: 1.5rem;
		color: ${colors.textDark};
	}

	@media ${device.tablet} {
		.content {
			padding: 20px;
		}
	}

	@media ${device.mobile} {
		.content {
			padding: 20px;
		}
	}
`;
